var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.48 0.5 0 4.98 0 10.5C0 16.02 4.48 20.5 10 20.5C15.52 20.5 20 16.02 20 10.5C20 4.98 15.52 0.5 10 0.5ZM13.61 6.84C14.68 6.84 15.54 7.7 15.54 8.77C15.54 9.84 14.68 10.7 13.61 10.7C12.54 10.7 11.68 9.84 11.68 8.77C11.67 7.7 12.54 6.84 13.61 6.84ZM7.61 5.26C8.91 5.26 9.97 6.32 9.97 7.62C9.97 8.92 8.91 9.98 7.61 9.98C6.31 9.98 5.25 8.92 5.25 7.62C5.25 6.31 6.3 5.26 7.61 5.26ZM7.61 14.39V18.14C5.21 17.39 3.31 15.54 2.47 13.18C3.52 12.06 6.14 11.49 7.61 11.49C8.14 11.49 8.81 11.57 9.51 11.71C7.87 12.58 7.61 13.73 7.61 14.39ZM10 18.5C9.73 18.5 9.47 18.49 9.21 18.46V14.39C9.21 12.97 12.15 12.26 13.61 12.26C14.68 12.26 16.53 12.65 17.45 13.41C16.28 16.38 13.39 18.5 10 18.5Z",
    fill: "#0A4468"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.609e08b9a904bd04c60606a27950caba.svg";
export { ForwardRef as ReactComponent };